module.exports = __webpack_public_path__ + "img/logo-light.114052b7.png";